import React from 'react';
import Header from '@/components/Header';
import Hero from '@/components/Hero';
import BrandMarquee from '@/components/BrandMarquee';
import GuaranteeBar from '@/components/GuaranteeBar';
import Services from '@/components/Services';
import GuildBanner from '@/components/GuildBanner';
import Wrapulator from '@/components/Wrapulator';
import Portfolio from '@/components/Portfolio';
import Membership from '@/components/Membership';
import Testimonials from '@/components/Testimonials';
import InstallerJoin from '@/components/InstallerJoin';
import QuoteSection from '@/components/QuoteSection';
import Faq from '@/components/Faq';
import Footer from '@/components/Footer';
import { useAudience } from '@/context/AudienceContext';

export default function HomePage() {
  const { isB2B } = useAudience();
  return (
    <div className="relative">
      <Header />
      <main>
        <Hero />
        <BrandMarquee />
        <GuaranteeBar />
        <Services />
        {/* Retail visitors want the pricing calculator first, then the installer directory.
            B2B keeps the original order (Guild-first) since Install Guild is core to the partnership pitch. */}
        {isB2B ? (
          <>
            <GuildBanner />
            <Wrapulator />
          </>
        ) : (
          <>
            <Wrapulator />
            <GuildBanner />
          </>
        )}
        <Portfolio />
        <Membership />
        <Testimonials />
        <InstallerJoin />
        <QuoteSection />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}
